import { isWxMpWebview } from '@/utils/env'

// 智能管家app 客户端通信工具(android)
function connectWebViewJavascriptBridge(callback) {
    if (isWxMpWebview()) return
    if (/Android/i.test(navigator.userAgent)){
        if (window.WebViewJavascriptBridge) {
            console.log('判断是否存在开始------------')
            callback(WebViewJavascriptBridge);
        } else {
            document.addEventListener("WebViewJavascriptBridgeReady", () => {
                console.log('判断是否存在开始------------')
                callback(WebViewJavascriptBridge);
                },
                false,
            );
        }
    }else if (/iPhone/i.test(navigator.userAgent)){
        //ios注册事件监听
        if (window.WebViewJavascriptBridge) { return callback(WebViewJavascriptBridge); }
        if (window.WVJBCallbacks) { return window.WVJBCallbacks.push(callback); }
        window.WVJBCallbacks = [callback];
        var WVJBIframe = document.createElement('iframe');
        WVJBIframe.style.display = 'none';
        WVJBIframe.src = 'https://__bridge_loaded__';
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function() { document.documentElement.removeChild(WVJBIframe) }, 0)
    }
}
// 初始化通信
connectWebViewJavascriptBridge(bridge => {
    //初始化
    //android必须要bridge.init方法，ios不可以有bridge.init方法，否则不能正常和APP交互
    if (/Android/i.test(navigator.userAgent)){
        bridge.init((message, responseCallback) => {
            responseCallback(message);
        });
    }
});
// 注册通信事件
function callNative(name, data) {
    // console.log('注册通信事件========',name, data)
    return new Promise((resolve, reject) => {
        connectWebViewJavascriptBridge(bridge => {
            bridge.callHandler(name, data, res => {
                try {
                    console.log('注册通信事件1========',name, JSON.parse(res))
                    resolve(JSON.parse(res))
                } catch (error) {
                    console.log('注册通信事件2========',name,res)
                    resolve(res)
                }
            });
        });
    })
}

//Android调用js方法：functionInJs方法名称需要保持一致
function androidFn(name, data) {
    return new Promise((resolve, reject) => {
        connectWebViewJavascriptBridge(bridge => {
            bridge.registerHandler(name, data, res => {
                try {
                    resolve(JSON.parse(res))
                } catch (error) {
                    resolve(res)
                }
            });
        });
    })
}

/**
 * 获取设备信息
 * @param {*} data 无需传入直接调用
 * @returns {object} 返回客户端数据
 * @userId {number} 用户id
 * @token {string} 登录标识
 */
export const getNativeInfo = function (data = {}) {
    return callNative('appParams', data)
}

/**
 * 通知客户端显示页面
 * @param {*} data 无需传入直接调用
 * @returns 无返回
 */
export const showWebview = function (data = {}) {
    return callNative('requestComplete', data)
}

/**
 * 通知客户端关闭页面
 * @param {*} data 无需传入直接调用
 * @returns 无返回
 */
export const closeWebview = function (data = {}) {
    return callNative('returnApp', data)
}

/**
 * 播报文本
 * @param {*} data 要播报的字符串
 * @returns 无返回
 */
export const textBroadcast = function (data = {}) {
    return callNative('handlerTts', data)
}
/**
 * 获取通讯录信息
 * @param {*} data 无需传入直接调用
 * @returns {Array} 返回通讯录json数组 contactId="通讯录ID"，displayName="通讯录姓名"，phoneNumber="电话"
 */
export const getAddressBook= function (data = {}) {
    return callNative('readContact', data)
}

/**
 * 控制页面高度
 * @param {*} data 值用0到1，支持两位小数代表百分比，值越大展示的越多,默认按百分之77展示
 * @returns 无返回
 */
export const pagePercentage= function (data = {}) {
    console.log('控制页面高度========', data)
    return callNative('pagePercentage', data)
}
/**
 * 退出登陆
 * @param {*} 无需传入直接调用
 * @returns 无返回
 */
export const webLogout= function (data = {}) {
    return callNative('webLogout', data)
}

/**
 * 获取话题相关商品列表数据（传给服务生成订单方案）
 * @param {*} data 无需传入直接调用
 * @returns {array[object]} 商品列表数据
 */
export const purchasingList = function (data = {}) {
    return callNative('purchasingList', data)
}
/**
 * 通知app打开扫一扫
 * @param {*} data 无需传入直接调用
 */
export const openQRCodeScan = function (data = {}) {
    return callNative('openQRCodeScan', data)
}

/**
 * 监听android扫一扫返回结果
 * @param {*} data 无需传入直接调用
 * @returns {params:string} 扫描结果
 */
export const qrCodeResult = function (data = {}) {
    return androidFn('qrCodeResult', data)
}

/**
 * 通知app好友邀请处理信息
 * @param {*} data 邀请id
 */
export const processFriendInvite = function (data = {}) {
    return callNative('processFriendInvite', data)
}


/**
 * 监听android好友邀请申请
 * @param {*} data 无需传入直接调用
 * @returns {params:string} 申请通知
 */
export const refreshMessageFromPush = function (data = {}) {
    return androidFn('refreshMessageFromPush', data)
}


/**
 *  将h5的token信息存到app--解决h5缓存丢失问题
 * @param {object} data 
 */
export const webSaveParams = function (data = {}) {
    return callNative('webSaveParams', data)
}


/**
 * 读取h5存到app缓存
 * @param {*} data 无需传入直接调用
 */
export const webReadParams = function (data = {}) {
    return callNative('webReadParams', data)
}

/**
 * 设置数字人声音开关功能
 * @param {*} data 传参“off”代表关闭，“on”代表打开，都是字符串类型
 */
export const autoTts = function (data = {}) {
    return callNative('autoTts', data)
}
/**
 * 跳转生命殇页面
 * @param {*} data 
 */
export const openEntropyReport = function (data = {}) {
    return callNative('openEntropyReport', data)
}
/**
 * 跳转我的设备
 * @param {*} data 
 */
export const openIotDevices = function (data = {}) {
    return callNative('openIotDevices', data)
}
/**
 * 跳转设备上传页面
 * @param {*} data  ALL（所有）、WEIGHT（体重）、BLOOD_PRESSURE（血压）、PRESSURE（压力）、BLOOD_OXYGEN (血氧设备)、BLOOD_GLUCOSE (血糖设备)、 PULSE_DIAGNOSIS(脉诊)
 */
export const openIotDevicesWithType = function (data = {}) {
    return callNative('openIotDevicesWithType', data)
}
/**
 * 跳转医生推荐页面，获取推荐医生列表
 * @param {*} data 无需传入直接调用
 */
export const doctorRecommendations = function (data = {}) {
    return callNative('doctorRecommendations', data)
}
/**
 * 保存图片到手机
 * @param {*} data base64
 */
export const webSaveImage = function (data = {}) {
    return callNative('webSaveImage', data)
}
/**
 * 跳转到app动态血糖页面
 * @param {*} data 无需传入直接调用
 * data.userType 当前登录账号的用户类型，0:医生，1:患者
 * data.userId 要查看动态血糖的用户的id
 */
export const wtDynamicBloodGlucose = function (data = {}) {
    return callNative('wtDynamicBloodGlucose', data)
}
/**
 * 打开设置页面
 * @param {*} data 无需传入直接调用
 */
export const webOpenSet = function (data = {}) {
    return callNative('webOpenSet', data)
}
/**
 * 打开链接传过来对应的url
 * @param {string} data 页面url地址
 */
export const webOpenUrl = function (data = {}) {
    return callNative('webOpenUrl', data)
}

/**
 * 打开新的webview窗口
 * @param {string} data.url 页面url地址
 * @param {string} data.type 页面类型 默认为1:通屏幕展示
 */ 
export const webOpenWindow = function (data = {}) {
    return callNative('webOpenWindow', data)
}

/**
 * 打开编辑用户信息页面
 * @param {*} data 无需传入直接调用
 */
export const editUserInformation = function (data = {}) {
    return callNative('editUserInformation', data)
}
/**
 * 打开pdf文件
 * @title {string} 页面标题
 * @fileName {string} pdf文件名称
 * @fileUrl {string} pdf文件地址
 */
export const openPdf = function (data = {}) {
    return callNative('openPdf', data)
}
/**
 * 下载文件
 * @title {string} 页面标题
 * @fileName {string} pdf文件名称
 * @fileUrl {string} pdf文件地址
 * @fileUuid {string} 文件uuid
 */
export const openFile = function (data = {}) {
    return callNative('openFile', data)
}
/**
 * 获取导航栏高度
 * @param {*} data 无需传入直接调用
 * @returns {object} 返回导航栏高度
 *  object.height 状态栏加导航栏的高度
 *  object.show true代表我这边状态栏设置了透明，false代表我这边没设置透明
 *  object.statusBarHeight 状态栏的高度
 */
export const statusBarParams = function (data = {}) {
    return callNative('statusBarParams', data)
}
/**
 * 清除app缓存
 * @param {*} data 无需传入直接调用
 */
export const webClearData = function (data = {}) {
    return callNative('webClearData', data)
}
/**
 * 跳转到app智能问诊
 * @param {Object} data - 传递给智能问诊页面的数据
 * @param {string} data.type - 指定问诊类型 bloodSugar:血糖 bloodPressure:血压
 * @param {string} data.param - 后端返回的数据
 */
export const monitorData = function (data = {}) {
    return callNative('monitorData', data)
}
/**
 * h5获取最新动态血糖数据
 * @param {*} data 无需传入直接调用
 */
export const wtDynamicData = function (data = {}) {
    return callNative('wtDynamicData', data)
}
/**
 * 打开脉诊页面，并传递参数
 * @param {*} data 
 * @param {string} data.type 类型 pulse_exam脉诊 ， face_tongue_exam:面舌诊评估
 * @param {string} data.taskID 任务id
 */
export const openIotDevicesWithExamType = function (data = {}) {
    return callNative('openIotDevicesWithExamType', data)
}
/**
 * 打开通讯录搜索
 * @param {*} data 无需传入直接调用
 */
export const openAddressBookSearch = function (data = {}) {
    return callNative('openAddressBookSearch', data)
}
/**
 * 打开发现内容页面 type，uuid，commentId
 * @param {*} data 无需传入直接调用
 * data.type 类型: 图文 视频
 * data.uuid 内容id
 * data.commentId 评论id
 */
export const openDiscoverContent = function (data = {}) {
    return callNative('openDiscoverContent', data)
}


/**
 * 举报功能
 * @param {object} data 
 * @param {object} data.msgData 消息体数据
 * @returns status 状态 0:成功 1:取消
 */
export const report = function (data = {}) {
    if (typeof data === 'object') data = JSON.stringify(data)
    return callNative('report', data)
}
/**
 * 复制文本
 * @param {*} data 无需传入直接调用
 *  data.text 文本
 * @returns {params:string} 返回结果 "1"成功 "0"失败
 */
export const copyText = function (data = {}) {
    return callNative('copyText', data)
}

/**
 * 获取体检报告基础信息
 * @param {*} data 无需传入直接调用
 * @returns {object} 返回体检报告基础信息
 *  object.type 类型
 *  object.data 数据
 */
export const evaluationIntSourceData = function (data = {}) {
    return callNative('evaluationIntSourceData', data)
}
/**
 * 生命殇报告打开智能助手
 * @param {*} data 无需传入直接调用
 */
export const openAssistant = function (data = {}) {
    return callNative('openAssistant', data)
}
/**
 * 生命殇报告-重新评估
 * @param {*} data 无需传入直接调用
 */
export const openEvaluationReport = function (data = {}) {
    return callNative('openEvaluationReport', data)
}
/**
 * 生命殇报告-关闭
 * @param {*} data 无需传入直接调用
 */
export const evaluationReportClose = function (data = {}) {
    return callNative('evaluationReportClose', data)
}
/**
 * 隐藏web导航栏
 * @param {string}  1. 隐藏  0 显示 (字符串类型)
 */
export const isHideWebNavBar = function (data = {}) {
    return callNative('isHideWebNavBar', data)
}
/**
 * 打开体重妙计相机
 * @param {string}  无需传入直接调用
 */
export const openTipsCamera = function (data = {}) {
    return callNative('openTipsCamera', data)
}
/**
 * 体重妙计相机-返回结果
 * @param {string}  无需传入直接调用
 */
export const tipsCameraResult = function (data = {}) {
    return androidFn('tipsCameraResult', data)
}
/**
 * 打开体重秤
 * @param {string}  无需传入直接调用
 */
export const startWeighing = function (data = {}) {
    return callNative('startWeighing', data)
}

/**
 * 控制状态看隐藏/可见
 * 0:隐藏，“1”可见
 * @param {string}  无需传入直接调用
 */
export const setStatusBarVisible = function (data = {}) {
    return callNative('setStatusBarVisible', data)
}
/**
 * 打开健康指标页面
 * 身体指标-跳转到健康指标页面
 * @param {string}  无需传入直接调用
 */
export const pushHealthIndicatorsView = function (data = {}) {
    return callNative('pushHealthIndicatorsView', data)
}
/**
 * 手势返回监听：nativeBack
 * @param {*} data 无需传入直接调用
 */
export const nativeBack = function (data = {}) {
    return androidFn('nativeBack', data)
}
/**
 * 调起拍照：webOpenCamera
 * @param {*} data 无需传入直接调用
 */
export const webOpenCamera = function (data = {}) {
    return callNative('webOpenCamera', data)
}
/**
 * 调起相册：webOpenAlbum
 * @param {*} data 无需传入直接调用
 */
export const webOpenAlbum = function (data = {}) {
    return callNative('webOpenAlbum', data)
}
/**
 * 监听图片结果
 * @param {*} data 无需传入直接调用
 */
export const watchImgResult = function (data = {}) {
    return androidFn('watchImgResult', data)
}
/**
 * 指血血糖-动态血糖切换：glucoseModeSwitch // 1切换为指血模式，2切换为动态模式
 * @param {*} data 无需传入直接调用
 */
export const glucoseModeSwitch = function (data = {}) {
    return callNative('glucoseModeSwitch', data)
}
export default {
    getNativeInfo,
    showWebview,
    closeWebview,
    textBroadcast,
    getAddressBook,
    pagePercentage,
    webLogout,
    purchasingList,
    openQRCodeScan, 
    qrCodeResult,
    processFriendInvite,
    refreshMessageFromPush,
    webSaveParams,
    webReadParams,
    autoTts,
    openEntropyReport,
    openIotDevices,
    openIotDevicesWithType,
    doctorRecommendations,
    webSaveImage,
    wtDynamicBloodGlucose,
    webOpenSet,
    webOpenUrl,
    editUserInformation,
    openPdf,
    openFile,
    statusBarParams,
    monitorData,
    webClearData,
    wtDynamicData,
    openIotDevicesWithExamType,
    openAddressBookSearch,
    openDiscoverContent,
    report,
    copyText,
    evaluationIntSourceData,
    openAssistant,
    openEvaluationReport,
    evaluationReportClose,
    isHideWebNavBar,
    webOpenWindow,
    openTipsCamera,
    startWeighing,
    setStatusBarVisible,
    tipsCameraResult,
    pushHealthIndicatorsView,
    nativeBack,
    webOpenCamera,
    webOpenAlbum,
    glucoseModeSwitch,
    watchImgResult,
}

/**
 * url参数
 * pagePercentage值用0到1，支持两位小数代表百分比，值越大展示的越多
 * statusBarColor=#FFFFFF 代表状态栏颜色，不传默认黑色
 */


/**
 * 
 * WEB_HANDLER模式的话是你通知我我才打开
 * PAGE_START是开始加载你那个页面的时候就打开
 * PAGE_FINISH是加载你的页面结束的时候打开
 */